/** @module Auth0SpinHelper */
/* eslint-disable import/extensions */
import { Auth0PageBase } from './auth0-page-template.mst.mjs';

class Auth0SpinHelper extends Auth0PageBase {
  constructor(options) {
    super(options);
    this._waitTextOverrideKey = options.waitTextOverrideKey;
    this._waitTextReplacementArgs = options.waitTextReplacementArgs;
  }

  async _onLoad() {
    await super._onLoad();
    // called when render of underlying template is complete
    await this._startUi();
  }

  async _applyWhiteLabel() {
    // called when render of underlying template is complete
    await super._applyWhiteLabel();

    this.toolbarVisible = false;
    this.languageSelectorVisible = false;
    this.actionLinkVisible = false;
  }

  /**
   * @function
   * @async
   */
  async _startUi() {
    await super._startUi();
    this._showPage();
    await this.showSpinner(this._waitTextOverrideKey, this._waitTextReplacementArgs);
  }
}

export default Auth0SpinHelper;
